import { gql } from '@apollo/client';

export const CREATE_SCHOOL_EDUCATORS = gql`
  mutation createSchoolEducators($inputs: [CreateSchoolEducatorInput!]!) {
    educators: createSchoolEducators(inputs: $inputs) {
      id
    }
  }
`;
